<template>
    <div class=''>
        <div class="main_top flex-around">
            <div class="top_left mr70">
                <div class="top_tips "><span class="ml20"><slot name="stockName"></slot></span></div>
                <div class="content"><slot name="stockDescription"></slot></div>
            </div>
            <div class="top_img"></div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {}
    },
created(){},
methods:{}
}
</script> 

<style lang='scss' scoped>
.stock_detail{
    width: 95%;
    padding-bottom: 100px;
    .main_top{
        width: 90%;
        padding: 30px 80px;
        border-radius: 10px 10px 0px 0px;
        margin-left: -1%;
        background: #fff;
        .top_left{
            width: 50%;
            .content{
                font-size: 20px;
                color: #271B63;
            }
        }
        .top_img{
            width: 650px;
            height: 298px;
            background: url(../../assets/img/ariximg.png) 0 0/100% 100% no-repeat;
        }
    }
}
</style>